import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type Review from 'modules/reviews/store/models/v2/Review'

interface RestartReviewModalProps {
  review: Review
  onClose: () => void
}

const RestartReviewModal = ({ review, onClose }: RestartReviewModalProps) => {
  const generalDescription = i18n.t('surveys.review.settings.restart.modal.description')

  const modalDescription = () => {
    if (review.isDaysToAnswerSet && review.hasSchedule && review.isEndOnSet) {
      return (
        generalDescription +
        ' ' +
        i18n.t('surveys.review.settings.restart.modal.description_with_days_to_answer_and_end_on')
      )
    } else if (review.hasSchedule && review.isEndOnSet) {
      return (
        generalDescription +
        ' ' +
        i18n.t('surveys.review.settings.restart.modal.description_with_end_on')
      )
    } else if (review.isDaysToAnswerSet) {
      return (
        generalDescription +
        ' ' +
        i18n.t('surveys.review.settings.restart.modal.description_with_days_to_answer')
      )
    }

    return generalDescription
  }

  const { running, performAction: restartReview } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await review.startReview()
      review.fetch()
      closePortal()
    },
    {
      successMessage: i18n.t('common.saved_successfully'),
    }
  )

  return (
    <Modal
      illustration="alert"
      title={i18n.t('surveys.review.settings.restart.modal.title')}
      description={modalDescription()}
      onClose={onClose}
      onSubmit={restartReview}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(RestartReviewModal)
